import React, { PureComponent } from 'react';
import { Result } from 'antd';

class Maintenance extends PureComponent {
  render() {
    return (
      <Result
        status="403"
        title="UNDER MAINTENANCE"
        subTitle="Sorry Business Central Dashboard is Under Maintenance "
      />
    );
  }
}
export default Maintenance;
